import "./Footer.scss";
const Footer = () => {
  return (
    <div className="footer-container">
      <p className="open-sans ">
        Made by <span>Emmanuelle Baron - 2021</span>
      </p>
    </div>
  );
};

export default Footer;
